import { ConsentType } from '@/enums'

export class PatientAvailableConsent {
  constructor(init: Partial<PatientAvailableConsent> = {}) {
    this.type = init.type
    this.isRequired = init.isRequired || false
    this.version = init.version || 1
    this.acceptText = init.acceptText
  }

  type?: ConsentType
  isRequired: boolean
  version: number
  acceptText?: string
}
